import React from 'react';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _wrapRegExp(re, groups) {
  _wrapRegExp = function _wrapRegExp(re, groups) {
    return new BabelRegExp(re, undefined, groups);
  };

  var _RegExp = _wrapNativeSuper(RegExp);

  var _super = RegExp.prototype;

  var _groups = new WeakMap();

  function BabelRegExp(re, flags, groups) {
    var _this = _RegExp.call(this, re, flags);

    _groups.set(_this, groups || _groups.get(re));

    return _this;
  }

  _inherits(BabelRegExp, _RegExp);

  BabelRegExp.prototype.exec = function (str) {
    var result = _super.exec.call(this, str);

    if (result) result.groups = buildGroups(result, this);
    return result;
  };

  BabelRegExp.prototype[Symbol.replace] = function (str, substitution) {
    if (typeof substitution === "string") {
      var groups = _groups.get(this);

      return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) {
        return "$" + groups[name];
      }));
    } else if (typeof substitution === "function") {
      var _this = this;

      return _super[Symbol.replace].call(this, str, function () {
        var args = [];
        args.push.apply(args, arguments);

        if (typeof args[args.length - 1] !== "object") {
          args.push(buildGroups(args, _this));
        }

        return substitution.apply(this, args);
      });
    } else {
      return _super[Symbol.replace].call(this, str, substitution);
    }
  };

  function buildGroups(result, re) {
    var g = _groups.get(re);

    return Object.keys(g).reduce(function (groups, name) {
      groups[name] = result[g[name]];
      return groups;
    }, Object.create(null));
  }

  return _wrapRegExp.apply(this, arguments);
}

function getVariantSrc(variant) {
  return variant.url + " " + variant.width + "w";
}

var Image = function Image(_ref) {
  var _biggestImage, _biggestImage2, _caption$html, _caption$plainText;

  var children = _ref.children,
      restOfAllProps = _objectWithoutPropertiesLoose(_ref, ["children"]);

  var src = restOfAllProps.src,
      url = restOfAllProps.url,
      sizes = restOfAllProps.sizes,
      variants = restOfAllProps.variants,
      altText = restOfAllProps.altText,
      altPassed = restOfAllProps.alt,
      caption = restOfAllProps.caption,
      className = restOfAllProps.className,
      rest = _objectWithoutPropertiesLoose(restOfAllProps, ["src", "url", "sizes", "variants", "altText", "alt", "caption", "className"]);

  var vars = (variants || []).filter(function (v) {
    return !!v;
  });
  var alt = typeof altPassed === 'string' ? altPassed : altText;
  var hasVariants = vars.length > 0; // Get the biggest image from the variants

  var biggestImage = vars[0];

  if (hasVariants) {
    biggestImage = vars.reduce(function (acc, v) {
      if (!acc.width || v.width > acc.width) {
        return v;
      }

      return acc;
    }, vars[0]);
  } // Determine srcSet


  var std = vars.filter(function (v) {
    return v.url && !v.url.endsWith('.webp');
  });
  var webp = vars.filter(function (v) {
    return v.url && v.url.endsWith('.webp');
  });
  var srcSet = std.map(getVariantSrc).join(', ');
  var srcSetWebp = webp.map(getVariantSrc).join(', '); // Determine the original file extension

  var originalFileExtension = 'jpeg';

  if (std.length > 0) {
    var match = std[0].url.match( /*#__PURE__*/_wrapRegExp(/\.((?:(?!\.)[\s\S])+)$/, {
      name: 1
    }));
  }

  var commonProps = {
    // Ensure fallback src for older browsers
    src: src || url || (hasVariants ? std[0].url : undefined),
    alt: alt,
    caption: caption,
    width: (_biggestImage = biggestImage) == null ? void 0 : _biggestImage.width,
    height: (_biggestImage2 = biggestImage) == null ? void 0 : _biggestImage2.height
  };

  if (children) {
    return children(_extends({
      srcSet: srcSet,
      srcSetWebp: srcSetWebp,
      className: className,
      sizes: sizes
    }, commonProps, rest, {
      originalFileExtension: originalFileExtension
    }));
  }

  var captionString = (caption == null ? void 0 : (_caption$html = caption.html) == null ? void 0 : _caption$html[0]) || (caption == null ? void 0 : (_caption$plainText = caption.plainText) == null ? void 0 : _caption$plainText[0]) || '';
  var hasCaption = Boolean(captionString);
  return React.createElement("figure", null, React.createElement("picture", {
    className: className
  }, srcSetWebp.length > 0 && React.createElement("source", {
    srcSet: srcSetWebp,
    type: "image/webp",
    sizes: sizes
  }), srcSet.length > 0 && React.createElement("source", {
    srcSet: srcSet,
    type: "image/" + originalFileExtension,
    sizes: sizes
  }), React.createElement("img", Object.assign({}, commonProps, rest))), hasCaption && React.createElement("figcaption", {
    dangerouslySetInnerHTML: {
      __html: captionString
    }
  }));
};

export { Image };